import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { DownloadIcon, SearchIcon, HeartIcon } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    icon: <DownloadIcon className="w-6 h-6" data-id="element-146" />,
    title: 'Descarga',
    desc: 'Obtén acceso inmediato al PDF en tu correo.'
  }, {
    num: '2',
    icon: <SearchIcon className="w-6 h-6" data-id="element-147" />,
    title: 'Identifica',
    desc: 'Lee los 7 síntomas y localiza el tuyo en menos de 20 minutos.'
  }, {
    num: '3',
    icon: <HeartIcon className="w-6 h-6" data-id="element-148" />,
    title: 'Reconecta',
    desc: 'Aplica el micro-ejercicio diario y observa cómo cambia el ambiente en tu casa desde la primera noche.'
  }];
  return <section id="steps" className="py-32 px-4 md:px-8 bg-white relative" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <FadeIn className="text-center mb-24" data-id="element-151">
          <h2 className="text-4xl md:text-5xl font-serif text-burgundy-dark mb-6" data-id="element-152">
            ¿Cómo funciona?
          </h2>
          <div className="w-16 h-[2px] bg-gold mx-auto rounded-full" data-id="element-153"></div>
        </FadeIn>

        <div className="relative" data-id="element-154">
          {/* Animated Connecting Line for Desktop */}
          <div className="hidden md:block absolute top-16 left-[15%] right-[15%] h-[2px] bg-cream-dark z-0" data-id="element-155">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '100%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut',
            delay: 0.2
          }} className="h-full bg-gold" data-id="element-156" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 relative z-10" data-id="element-157">
            {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.4} className="flex flex-col items-center text-center group" data-id="element-158">
                <div className="relative mb-8" data-id="element-159">
                  {/* Animated Ring */}
                  <motion.svg className="absolute -inset-4 w-[calc(100%+32px)] h-[calc(100%+32px)] -rotate-90 text-gold" viewBox="0 0 100 100" data-id="element-160">
                    <motion.circle cx="50" cy="50" r="48" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="301.59" initial={{
                  strokeDashoffset: 301.59
                }} whileInView={{
                  strokeDashoffset: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  delay: idx * 0.4 + 0.2,
                  ease: 'easeOut'
                }} data-id="element-161" />
                  </motion.svg>

                  <div className="w-32 h-32 rounded-full bg-cream flex flex-col items-center justify-center border-8 border-white shadow-xl relative z-10 group-hover:bg-rose-light transition-colors duration-500" data-id="element-162">
                    <span className="text-sm font-bold text-gold-dark mb-1" data-id="element-163">
                      Paso {step.num}
                    </span>
                    <div className="text-burgundy-dark" data-id="element-164">{step.icon}</div>
                  </div>
                </div>

                <h3 className="text-2xl font-serif font-bold text-burgundy-dark mb-4 group-hover:text-gold-dark transition-colors" data-id="element-165">
                  {step.title}
                </h3>
                <p className="text-charcoal-light leading-relaxed px-4 text-lg" data-id="element-166">
                  {step.desc}
                </p>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}